module.exports = __webpack_public_path__ + "media/brands/ford-6b31ba37.png";